/* global toastr */
import React from 'react'
import { Link } from 'react-router-dom'
import { wrapView, request, format_date } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { store } from '../index'
import { SigurModelView } from '../lib/SigurModelView'
import { Panel } from '../smart_bps/lib/components'
import { ApprovalsModalSearch } from './ApprovalsModalSearch'
import { SigurPopover } from '../lib/SigurPopover'
import { SigurFilesBlock } from '../lib/SigurFilesBlock'
import AttrInput from '../smart_bps/lib/attr_input'

class ModelView extends SigurModelView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      accessObjects: [],
      objectGroups: [],
      modes: [],
      expandedGroupId: null,
      groupAccessObjects: {},
      showApproveModal: false,
      showReturnModal: false,
      approveNote: '',
      returnNote: '',
      returnNoteError: null,
      showModesModal: false,
      modalModes: [],
      modalModesPage: 1,
      modalModesTotalPages: 1,
      modalModesLevelChoices: [],
      modalModesSelectedIds: new Set(),
      modalModesExcludedIds: new Set(),
      modalModesFilters: { name: '', level: '', territory_name: '' },
      modesFilterOptions: { territories: [] },
      showObjectStatusModal: false,
      objectStatusTarget: null,
      objectStatusRefusalReason: '',
      objectStatusDetails: null,
      statusPopoverKey: null,
      requestMeta: [],
      isModalModesSelectedAll: false,
    }
    this.loadAccessObjects = this.loadAccessObjects.bind(this)
    this.loadObjectGroups = this.loadObjectGroups.bind(this)
    this.loadModes = this.loadModes.bind(this)
    this.loadGroupAccessObjects = this.loadGroupAccessObjects.bind(this)
    this.toggleGroupExpand = this.toggleGroupExpand.bind(this)
    this.openApproveModal = this.openApproveModal.bind(this)
    this.closeApproveModal = this.closeApproveModal.bind(this)
    this.openReturnModal = this.openReturnModal.bind(this)
    this.closeReturnModal = this.closeReturnModal.bind(this)
    this.submitApprove = this.submitApprove.bind(this)
    this.submitReturn = this.submitReturn.bind(this)
    this.openModesModal = this.openModesModal.bind(this)
    this.closeModesModal = this.closeModesModal.bind(this)
    this.loadModalModes = this.loadModalModes.bind(this)
    this.handleModesSearch = this.handleModesSearch.bind(this)
    this.handleResetModesFilters = this.handleResetModesFilters.bind(this)
    this.handleToggleMode = this.handleToggleMode.bind(this)
    this.handleApplyModes = this.handleApplyModes.bind(this)
    this.handleRemoveMode = this.handleRemoveMode.bind(this)
    this.openObjectStatusModal = this.openObjectStatusModal.bind(this)
    this.closeObjectStatusModal = this.closeObjectStatusModal.bind(this)
    this.submitObjectStatus = this.submitObjectStatus.bind(this)
    this.takeApproval = this.takeApproval.bind(this)
    this.completeApproval = this.completeApproval.bind(this)
    this.fileBlockRef = React.createRef()
    this.loadRequestsMeta = this.loadRequestsMeta.bind(this)
  }

  takeApproval() {
    const that = this
    request({
      method: 'post',
      url: `/api/approvals/${this.object_id}/take_approval`,
      data: {},
      success: (data) => {
        that.documentToState(data)
        that.loadAccessObjects()
        that.getDocument()
        toastr.success('Согласование взято в работу')
      },
      error: (xhr) => {
        const msg = xhr.responseJSON?.detail || xhr.responseText || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : JSON.stringify(msg))
      },
    })
  }

  loadRequestsMeta() {
    // Если надо будет тянуть всё, может сразу ${this.state.request_id}/get_meta? Пока излишне.
    if (this.state.request_id) {
      request({
      method: 'get',
      url: `/api/approvals/${this.object_id}/requests/${this.state.request_id}/get_data`,
      success: (data) => {
        this.setState({
          requestMeta: data,
        })
      },
      error: (xhr) => {
        const msg = xhr.responseJSON?.detail || xhr.responseText || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : JSON.stringify(msg))
      },
    })
    }
  }

  invalidateApprovalsList() {
    store.dispatch({ type: `${PROJECT_NAME}_list_clean` })
  }

  completeApproval() {
    const that = this
    const default_tab = document.getElementById('tab-Основные-параметры')
    default_tab.click()

    request({
      method: 'post',
      url: `/api/approvals/${this.object_id}/complete_approval`,
      data: {},
      success: (data) => {
        that.invalidateApprovalsList()
        that.documentToState(data)
        that.loadAccessObjects()
        toastr.success('Согласование по уровню завершено')
      },
      error: (xhr) => {
        const msg = xhr.responseJSON?.detail || xhr.responseText || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : JSON.stringify(msg))
      },
    })
  }

  getFormSchema() {
    const schema = super.getFormSchema()
    const isWaitingFix = this.state.state === 'waiting_request_fix'
    const canSee = this.state.can_see_objects_tab
    let out = schema
    if (!canSee || isWaitingFix) {
      out = out.filter((item) => item[0] !== 'Согласование')
    }
    if (isWaitingFix) {
      out = out.filter((item) => item[0] !== 'Режимы доступа')
    }
    return out
  }

  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  componentDidMount() {
    super.componentDidMount?.()
    if (this.object_id && this.object_id !== 0) this.loadModes()
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate?.(prevProps, prevState)
    const requestId = this.state.request_id
    const hadRequestId = prevState.request_id
    const approvalId = this.object_id
    const hadApprovalId = prevState.object_id
    if (requestId && hadRequestId !== requestId) {
      this.loadAccessObjects()
      this.loadObjectGroups()
      this.loadRequestsMeta()
    }
    if (approvalId && hadApprovalId !== approvalId) {
      this.loadModes()
    }
    // При открытии вкладки «Согласование» подгружаем объекты по группам
    const { selected_tab, can_see_objects_tab, objectGroups, groupAccessObjects } = this.state
    if (can_see_objects_tab && selected_tab === 'Согласование' && objectGroups && objectGroups.length > 0) {
      objectGroups.forEach((og) => {
        if (!groupAccessObjects || !groupAccessObjects[og.object_group_id]) {
          this.loadGroupAccessObjects(og.object_group_id)
        }
      })
    }
  }

  loadAccessObjects() {
    const requestId = this.state.request_id
    if (!requestId) return
    const approvalId = this.object_id
    const url = `/api/requests/${requestId}/access_objects` +
      (approvalId && approvalId !== 0 ? `?approval_id=${approvalId}` : '')
    request({
      method: 'get',
      url,
      success: (data) =>
        this.setState({
          accessObjects: data.items || [],
          // Перезагрузить группы с approval_id, иначе останутся старые элементы без статусов
          groupAccessObjects: {},
        }),
      error: () => this.setState({ accessObjects: [] }),
    })
  }

  loadObjectGroups() {
    const requestId = this.state.request_id
    if (!requestId) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/object_groups`,
      success: (data) => this.setState({ objectGroups: data.items || [] }),
      error: () => this.setState({ objectGroups: [] }),
    })
  }

  loadModes() {
    const approvalId = this.object_id
    if (!approvalId || approvalId === 0) return
    request({
      method: 'get',
      url: `/api/approvals/${approvalId}/modes`,
      success: (data) => this.setState({ modes: data.items || [] }),
      error: () => this.setState({ modes: [] }),
    })
  }

  loadGroupAccessObjects(groupId) {
    const requestId = this.state.request_id
    if (!requestId) return
    const approvalId = this.object_id
    const url =
      `/api/requests/${requestId}/object_groups/${groupId}/access_objects` +
      (approvalId && approvalId !== 0 ? `?approval_id=${approvalId}` : '')
    request({
      method: 'get',
      url,
      success: (data) =>
        this.setState((s) => ({
          groupAccessObjects: { ...s.groupAccessObjects, [groupId]: data.items || [] },
        })),
      error: (data) =>
        this.setState((s) => ({
          groupAccessObjects: { ...s.groupAccessObjects, [groupId]: [] },
        })),
    })
  }

  toggleGroupExpand(groupId) {
    const { expandedGroupId, groupAccessObjects } = this.state
    if (expandedGroupId === groupId) {
      this.setState({ expandedGroupId: null })
      return
    }
    this.setState({ expandedGroupId: groupId }, () => {
      if (!groupAccessObjects[groupId]) this.loadGroupAccessObjects(groupId)
    })
  }

  openModesModal() {
    this.setState(
      {
        showModesModal: true,
        modalModesSelectedIds: new Set(),
        modalModesFilters: { name: '', level: '', territory_name: '' },
      },
      () => {
        this.loadModesFilterOptions()
        this.loadModalModes(1)
      }
    )
  }

  closeModesModal() {
    this.setState({ showModesModal: false })
  }

  loadModesFilterOptions() {
    const approvalId = this.object_id
    if (!approvalId) return
    request({
      method: 'get',
      url: `/api/approvals/${approvalId}/modes/filter_options`,
      success: (data) =>
        this.setState({
          modesFilterOptions: {
            territories: data.territories || [],
          },
        }),
      error: () => this.setState({ modesFilterOptions: { territories: [] } }),
    })
  }

  loadModalModes(page = 1) {
    const approvalId = this.object_id
    if (!approvalId) return
    const { modalModesFilters } = this.state
    request({
      method: 'post',
      url: `/api/approvals/${approvalId}/modes/list`,
      data: { page, page_size: 15, filters: modalModesFilters },
      success: (data) =>
        this.setState({
          modalModes: data.items || [],
          modalModesPage: data.page || 1,
          modalModesTotalPages: data.total_pages || 1,
          modalModesLevelChoices: data.level_choices || [],
          modelModesAlreadyAddedModesCnt: data.already_added_cnt || 0,
        }),
      error: () =>
        this.setState({
          modalModes: [],
          modalModesPage: 1,
          modalModesTotalPages: 1,
          modalModesLevelChoices: [],
        }),
    })
  }

  handleModesSearch() {
    this.loadModalModes(1)
  }

  handleResetModesFilters() {
    this.setState(
      { modalModesFilters: { name: '', level: '', territory_name: '' } },
      () => this.loadModalModes(1)
    )
  }

  handleToggleMode(modeId, isAlreadyAdded) {
    const { modalModesSelectedIds, modalModesExcludedIds, isModalModesSelectedAll } = this.state
    const newSelectedIds = isModalModesSelectedAll ? new Set(modalModesExcludedIds) : new Set(modalModesSelectedIds)

    if (newSelectedIds.has(modeId)) {
      newSelectedIds.delete(modeId)
    } else if (!isAlreadyAdded) {
      newSelectedIds.add(modeId)
    }

    this.setState({
      [isModalModesSelectedAll ? 'modalModesExcludedIds' : 'modalModesSelectedIds']: newSelectedIds,
    })

    if (isAlreadyAdded) {
      this.handleRemoveMode(modeId, true)
      this.setState(prevState => ({
        modalAccessObjects: prevState.modalAccessObjects.map(item =>
          item.id === modeId ? { ...item, already_added: false } : item
        )
      }));
    }
  }

  handleApplyModes() {
    const approvalId = this.object_id
    const { modalModesSelectedIds, modalModes, isModalModesSelectedAll, modalModesFilters } = this.state
    const toAdd = [...modalModesSelectedIds].filter(
      (id) => !modalModes.find((m) => m.id === id && m.already_added)
    )

    if (toAdd.length === 0 && !isModalModesSelectedAll) {
      this.closeModesModal()
      return
    }
    request({
      method: 'post',
      url: `/api/approvals/${approvalId}/modes/add`,
      data: {
        is_selected_all: isModalModesSelectedAll,
        mode_ids: toAdd,
        filters: modalModesFilters
      },
      success: () => {
        this.loadModes()
        this.closeModesModal()
        toastr.success('Режимы добавлены')
      },
      error: (e) => {
        const msg = e.detail?.detail || e.detail || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : 'Ошибка')
      },
    })
  }

  handleRemoveMode(modeId) {
    const approvalId = this.object_id
    request({
      method: 'post',
      url: `/api/approvals/${approvalId}/modes/remove`,
      data: { mode_id: modeId },
      success: () => {
        this.loadModes()
        toastr.success('Режим удалён')
      },
      error: (e) => {
        const msg = e.detail?.detail || e.detail || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : 'Ошибка')
      },
    })
  }

  openApproveModal() {
    this.setState({ showApproveModal: true, approveNote: '' })
  }
  closeApproveModal() {
    this.setState({ showApproveModal: false })
  }
  openReturnModal() {
    this.setState({ showReturnModal: true, returnNote: '', returnNoteError: null })
  }
  closeReturnModal() {
    this.setState({ showReturnModal: false, returnNoteError: null })
  }

  submitApprove() {
    const note = (this.state.approveNote || '').trim()
    request({
      method: 'post',
      url: `/api/approvals/${this.object_id}/approve`,
      data: { note: note || undefined },
      success: (data) => {
        this.invalidateApprovalsList()
        this.closeApproveModal()
        this.documentToState(data)
        toastr.success('Заявка согласована')
      },
      error: (data) => {
        const msg = data.detail?.detail || data.detail || 'Ошибка'
        toastr.error(typeof msg === 'string' ? msg : 'Ошибка')
      },
    })
  }

  submitReturn() {
    const note = (this.state.returnNote || '').trim()
    if (!note) {
      this.setState({ returnNoteError: 'Обязательное поле' })
      return
    }
    this.setState({ returnNoteError: null })
    request({
      method: 'post',
      url: `/api/approvals/${this.object_id}/return`,
      data: { note },
      success: (data) => {
        this.invalidateApprovalsList()
        this.closeReturnModal()
        this.documentToState(data)
        toastr.success('Заявка возвращена на доработку')
      },
      error: (data) => {
        const msg = data.detail?.detail ?? data.detail
        const message = typeof msg === 'string' ? msg : 'Обязательное поле'
        this.setState({ returnNoteError: message })
      },
    })
  }

  /** В карточке скрываем «Отбор» (presets) — он нужен только в списке. */
  renderTopPanelLeftItems() {
    const items = super.renderTopPanelLeftItems()
    if (!items || !Array.isArray(items)) return items
    return items.filter((item) => item && item.key !== 'presets')
  }

  /** Блок «Основная информация»: Контрагент, уведомление черного списка, Автор, Ответственный, Этап, Заявка. */
  renderInfo() {
    const fd = this.state.form_data || {}
    const state = this.state.state || 'draft'
    const requestState = this.state.request_state
    const requestApprovalStatus = this.state.request_approval_status
    let stateTitle = this.getChoice(`bps_${PROJECT_NAME}_state`, state) || '---'
    // Подпись только если заявка была возвращена с этапа «Согласование заявки» (review) на «Создание» (draft)
    const wasReturnedToDraft = state === 'approval' && requestState === 'draft' && requestApprovalStatus === 'returned'
    if (wasReturnedToDraft) {
      stateTitle = `${stateTitle} (ожидает доработки заявки)`
    }
    const responsibleName = this.getChoice('User', this.state.responsible_id) || '---'
    const requestId = this.state.request_id
    const contractorName = fd.request_contractor_name ?? '---'
    const contractorBlacklist = fd.request_contractor_blacklist === true || fd.request_contractor_blacklist === 'Да'
    const authorDisplay = fd.request_author_id ?? '---'

    const InfoRow = ({ label, value }) => (
      <div className="sigur-info-block__row">
        <span className="sigur-info-block__label">{label}</span>
        <span className="sigur-info-block__value">{value}</span>
      </div>
    )

    return (
      <Panel header="Основная информация" key="info_panel">
        <div className="sigur-info-block">
          <InfoRow label="Контрагент" value={contractorName} />
          {contractorBlacklist && (
            <div className="sigur-info-block__alert alert alert-danger d-flex align-items-center py-2 px-2 small mt-1 mb-2" role="alert">
              <i className="ti ti-alert-triangle me-2 flex-shrink-0" aria-hidden />
              <span className="fw-bold">Контрагент находится в Черном списке.</span>
            </div>
          )}
          <InfoRow label="Автор заявки" value={authorDisplay} />
          <InfoRow label="Этап" value={stateTitle} />
          {requestId != null && this.isAdmin && (
            <div className="sigur-info-block__row">
              <span className="sigur-info-block__label">Заявка</span>
              <Link
                to={`/requests/${requestId}/`}
                className="sigur-info-block__link text-decoration-none fw-medium"
              >
                № {requestId}
                <i className="ti ti-arrow-right ti-xs ms-1" aria-hidden />
              </Link>
            </div>
          )}
        </div>
      </Panel>
    )
  }

  renderContentRight() {
    const { request_id, requestMeta } = this.state
    if (this.object_id === 0) return []
    const routeBlock = this.renderApprovalRouteBlock()
    const blocks = [this.renderInfo()]
    if (routeBlock) {
      blocks.push(routeBlock)
    }

    if ((requestMeta.files_schema || []).length) {
      const requestFiles = <SigurFilesBlock
        key="request_files"
        project_name="requests"
        object_id={request_id}
        files_schema={requestMeta.files_schema || []}
        files={requestMeta.files || []}
        fileUploaded={() => {}}
        getChoice={this.getChoice}
        isRenderDataFields={true}
        customHeader={"Файлы заявки"}
        isRenderChevron={true}
        viewOnly
      />
      blocks.push(requestFiles)
    }

    const filesSchema = this.state.files_schema || []
    if (filesSchema.length > 0) {
      blocks.push(
        this.renderFileBlock(true)
      )
    }
    blocks.push(this.renderComments())
    return blocks
  }

  renderApprovalRouteBlock() {
    const route = this.state.approval_route || []
    const currentLevel = this.state.approval_route_level
    if (route.length === 0) return null
    return (
      <Panel header="Маршрут согласования" key="approval_route">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Уровень согласования</th>
                <th>Имя маршрута</th>
                <th>Согласующий</th>
                <th>Согласование завершено</th>
              </tr>
            </thead>
            <tbody>
              {route.map((row, idx) => (
                <tr
                  key={row.step_id || idx}
                  className={row.level === currentLevel ? 'table-warning fw-bold' : ''}
                >
                  <td>{row.level}</td>
                  <td>{row.name || '—'}</td>
                  <td>{row.approver || '---'}</td>
                  <td>{row.completed ? 'Да' : 'Нет'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  renderContentLeft() {
    return super.renderContentLeft()
  }

  /** Кнопки «Возврат», «Взять в работу», «Завершить согласование». */
  renderContentLeftActionLeftItems() {
    const items = super.renderContentLeftActionLeftItems()
    const showReturn = Boolean(this.state.can_return)
    const canTake = Boolean(this.state.can_take_approval)
    const canComplete = Boolean(this.state.can_complete_approval)
    const extra = []
    if (canTake) {
      extra.push(
        <span
          className="btn btn-outline-primary waves-effect p-2 me-2"
          onClick={this.takeApproval}
          key="take_approval_btn"
        >
          Взять в работу
        </span>
      )
    }
    if (canComplete) {
      extra.push(
        <span
          className="btn btn-outline-success waves-effect p-2 me-2"
          onClick={this.completeApproval}
          key="complete_approval_btn"
        >
          Завершить согласование
        </span>
      )
    }
    if (showReturn) {
      extra.push(
        <span
          className="btn btn-primary waves-effect p-2 me-2"
          onClick={this.openReturnModal}
          key="return_btn"
        >
          Вернуть
        </span>
      )
    }
    if (extra.length === 0) return items
    const deleteIdx = items.findIndex((x) => x && x.key === 'delete')
    const insertIdx = deleteIdx >= 0 ? deleteIdx + 1 : items.length
    return [...items.slice(0, insertIdx), ...extra, ...items.slice(insertIdx)]
  }

  renderFormAttr(attr, horizontal) {
    if (
      attr.name === 'modes_section_placeholder' ||
      attr.name === 'objects_for_approval_placeholder'
    )
      return null
    if (attr.name === 'request_territory_ids') {
      const data = this.state.form_data || {}
      const ids = Array.isArray(data.request_territory_ids) ? data.request_territory_ids : []
      return (
        <AttrInput
          key={attr.name}
          data_type="m2m_integer"
          widget="select2"
          choice_name="TerritoryDocument"
          choices={this.props.choices}
          name={attr.name}
          title={attr.title}
          value={ids}
          access="read"
          horizontal={horizontal || false}
          onChange={() => {}}
        />
      )
    }
    return super.renderFormAttr(attr, horizontal)
  }

  renderFormGroup(item, idx) {
    const tab_title = item[0]
    if (tab_title === 'Согласование') {
      if (this.state.selected_tab !== tab_title) return null
      return (
        <div key={idx}>
          {this.renderObjectsForApprovalTable()}
        </div>
      )
    }
    return super.renderFormGroup(item, idx)
  }

  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]
    if (tabTitle === 'Режимы доступа' && position === 'bottom') {
      return <React.Fragment key="modes_block">{this.renderModesTable()}</React.Fragment>
    }
    // «Согласование» рендерятся только в renderFormGroup (вкладка без дубля внизу)
    return null
  }

  openObjectStatusModal(obj) {
    const target = obj || null
    this.setState({
      showObjectStatusModal: true,
      objectStatusTarget: target,
      objectStatusRefusalReason: '',
      objectStatusDetails: null,
    })

    const accessObjectId = target && (target.access_object_id != null ? Number(target.access_object_id) : Number(target.id))
    if (!accessObjectId || Number.isNaN(accessObjectId) || !this.object_id) return

    const that = this
    request({
      method: 'get',
      url: `/api/approvals/${this.object_id}/access_objects/${accessObjectId}/modal_info`,
      success: (data) => {
        const details = data || {}
        that.setState({ objectStatusDetails: details })
        // Для иконок "действует/недействует" в SigurFilesBlock нужны document_dates
        request({
          method: 'get',
          url: `/api/access_objects/${accessObjectId}/document_dates`,
          success: (dd) => {
            that.setState((s) => ({
              objectStatusDetails: {
                ...(s.objectStatusDetails || details),
                document_dates: dd?.items || [],
              },
            }))
          },
          error: () => {
            // Если документные даты не загрузились — просто показываем файлы без валидности
            that.setState((s) => ({
              objectStatusDetails: {
                ...(s.objectStatusDetails || details),
                document_dates: [],
              },
            }))
          },
        })
      },
      error: () => this.setState({ objectStatusDetails: {} }),
    })
  }

  closeObjectStatusModal() {
    this.setState({
      showObjectStatusModal: false,
      objectStatusTarget: null,
      objectStatusRefusalReason: '',
      objectStatusDetails: null,
    })
  }

  submitObjectStatus(status) {
    const { objectStatusTarget, objectStatusRefusalReason } = this.state
    if (!objectStatusTarget || !this.object_id) return
    if (status === 'refused' && !(objectStatusRefusalReason || '').trim()) {
      toastr.error('Укажите причину отказа')
      return
    }
    const that = this
    const accessObjectId = objectStatusTarget.access_object_id != null
      ? Number(objectStatusTarget.access_object_id)
      : null
    if (accessObjectId == null || Number.isNaN(accessObjectId)) {
      toastr.error('Не удалось определить объект доступа')
      return
    }
    request({
      method: 'post',
      url: `/api/approvals/${this.object_id}/set_object_status`,
      data: {
        access_object_id: accessObjectId,
        status,
        refusal_reason: status === 'refused' ? (objectStatusRefusalReason || null) : null,
      },
      success: (data) => {
        that.closeObjectStatusModal()
        that.invalidateApprovalsList()

        if (data.success) {
          that.loadAccessObjects()
          that.getDocument()
          toastr.success(status === 'approved' ? 'Согласовано' : 'Отказано')
        } else {
          that.loadAccessObjects()
          that.getDocument()
          toastr.error(data.error_msg)
        }
      },
      // error: (xhr) => {
      //   const msg = xhr.responseJSON?.detail || xhr.responseText || 'Ошибка'
      //   toastr.error(typeof msg === 'string' ? msg : JSON.stringify(msg))
      // },
    })
  }

  renderObjectsForApprovalTable() {
    const accessObjects = this.state.accessObjects || []
    const objectGroups = this.state.objectGroups || []
    const groupAccessObjects = this.state.groupAccessObjects || {}
    const canSet = this.state.can_set_object_status

    const statusLabel = (item) => {
      if (item && item.refused_by_any) return 'Отказано'
      const s = item && item.approval_status
      if (!s) return 'Ожидает согласования'
      if (s === 'approved') return 'Согласовано'
      if (s === 'refused') return 'Отказано'
      return 'Ожидает согласования'
    }
    const statusClass = (item) => {
      if (item && item.refused_by_any) return 'sigur-approval-objects__row-status--refused'
      const s = item && item.approval_status
      if (s === 'approved') return 'sigur-approval-objects__row-status--approved'
      if (s === 'refused') return 'sigur-approval-objects__row-status--refused'
      return 'sigur-approval-objects__row-status--wait-approval'
    }
    const accessById = {}
    accessObjects.forEach((ao) => {
      accessById[ao.access_object_id] = ao
    })
    const objectIdsInGroups = new Set()

    objectGroups.forEach((og) => {
      (groupAccessObjects[og.object_group_id] || []).forEach((ao) => {
        if (ao.access_object_id != null) objectIdsInGroups.add(ao.access_object_id)
      })
    })
    const standaloneObjects = accessObjects.filter((ao) => !objectIdsInGroups.has(ao.access_object_id))
    const hasStandalone = standaloneObjects.length > 0
    const hasGroups = objectGroups.length > 0

    const renderObjectRow = (item, key) => {
      const fullItem = item.access_object_id != null ? accessById[item.access_object_id] || item : item
      // Кликабельность для изменения решения:
      // - если отказа нет — можно
      // - если отказ есть, то разрешаем менять только тому, кто сам выставил отказ (и не завершил согласование)
      const clickable = canSet && (!fullItem.refused_by_any || fullItem.my_approval_status === 'refused')
      const rowStatusLabel = statusLabel(fullItem)
      const refuserTip = rowStatusLabel === 'Отказано' && (fullItem.decided_by_name || fullItem.refusal_reason)
        ? `${fullItem.decided_by_name || ''}${fullItem.refusal_reason ? `: ${fullItem.refusal_reason}` : ''}`
        : null
      const name = fullItem.name || item.name || '—'
      return (
        <div key={key} className="sigur-approval-objects__row">
          <div className="sigur-approval-objects__row-name">
            {clickable ? (
              <button
                type="button"
                className="btn p-0 text-start text-decoration-none"
                onClick={() => this.openObjectStatusModal(fullItem)}
              >
                {name}
              </button>
            ) : (
              <span className={'sigur-info-block__label'}>{name}</span>
            )}
          </div>
          <span
            onMouseEnter={() => this.setState({ statusPopoverKey: key })}
            onMouseLeave={() => this.setState({ statusPopoverKey: null })}
          >
            <SigurPopover
              placement="top"
              className="sigur-approval-objects__row-status-popover"
              trigger={
                clickable ? (
                  <button
                    type="button"
                    onClick={() => this.openObjectStatusModal(fullItem)}
                    className={`sigur-approval-objects__row-status ${statusClass(fullItem)}`}
                  >
                    {statusLabel(fullItem)}
                  </button>
                ) : (
                  <span className={`sigur-approval-objects__row-status ${statusClass(fullItem)}`}>
                    {statusLabel(fullItem)}
                  </span>
                )
              }
              visible={
                !!refuserTip &&
                rowStatusLabel === 'Отказано' &&
                this.state.statusPopoverKey === key
              }
            >
              <div className="small">
                {fullItem.decided_by_name && (
                  <div>
                    <strong>{fullItem.decided_by_name}</strong>
                  </div>
                )}
                {fullItem.refusal_reason && <div>{fullItem.refusal_reason}</div>}
              </div>
            </SigurPopover>
          </span>
        </div>
      )
    }
    const uniqueAccessObjects = Array.from(
      Object.values(groupAccessObjects) // берём все массивы
        .flat() // сплющиваем в один
        .reduce((map, obj) => {
          if (obj.access_object_id != null && !map.has(obj.access_object_id)) {
            map.set(obj.access_object_id, obj)
          }
          return map
        }, new Map())
        .values()
    )
    return (
      <Panel header="" key="objects_for_approval">
        <div className="sigur-approval-objects">
          {(hasStandalone || hasGroups) && (
            <div className="sigur-approval-objects__section">
              <div className="sigur-approval-objects__section-title">Посетители</div>
              <div className="sigur-approval-objects__list">
                {standaloneObjects.map((item) => renderObjectRow(item, `ao-${item.access_object_id || item.id}`))}
                {uniqueAccessObjects.map((ao) =>
                  renderObjectRow(
                    ao,
                    `ao-${ao.access_object_id || ao.id}`
                  )
                )}
              </div>
            </div>
          )}
        </div>

        {this.renderObjectStatusModal()}
      </Panel>
    )
  }

  renderObjectStatusModal() {
    if (!this.state.showObjectStatusModal || !this.state.objectStatusTarget) return null
    const obj = this.state.objectStatusTarget
    const that = this
    const d = this.state.objectStatusDetails || {}
    const formatPassport = (v) => {
      if (v == null || v === '') return '—'
      const digits = String(v).replace(/\D/g, '')
      if (digits.length !== 10) return String(v)
      return `${digits.slice(0, 4)} ${digits.slice(4)}`
    }

    const yesNo = (v) => (v === true || v === 'true' || v === 'Да' ? 'Да' : 'Нет')
    const getMedicalExam = () => (d.medical_exam ? d.medical_exam : obj.medical_exam || '—')
    const getBlacklist = () => (d.blacklist !== undefined ? yesNo(d.blacklist) : obj.blacklist ? 'Да' : 'Нет')
    return (
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title sigur-approval-object-modal__title">{obj.name || 'Объект'}</h5>
              <button type="button" className="btn-close" aria-label="Закрыть" onClick={this.closeObjectStatusModal} />
            </div>
            <div className="modal-body">
              {(() => {
                const accessObjectId =
                  obj.access_object_id != null ? Number(obj.access_object_id) : Number(obj.id)
                return (
                  <div className="row g-3 align-items-stretch">
                      <div className="col-md-7">
                      <div className="card card-action sigur-approval-object-modal__safety-card mb-0">
                        <div className="card-header py-2 px-3">
                          <h5 className="card-action-title mb-0">Сведения</h5>
                          {/* Чтобы высота заголовка совпадала с блоком "Файлы" (там есть иконка сворачивания). */}
                          <div className="card-action-element d-flex align-items-center gap-2">
                            <ul className="list-inline mb-0 ms-auto">
                              <li className="list-inline-item">
                                <span className="card-collapsible pointer">
                                  <i
                                    className="tf-icons ti scaleX-n1-rtl ti-sm ti-chevron-down"
                                    aria-hidden="true"
                                    style={{ visibility: 'hidden' }}
                                  />
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="card-body p-0">
                          <table className="sigur-approval-object-modal__table mb-0">
                            <tbody>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Дата рождения</td>
                                <td>{d.birth_date ? format_date(d.birth_date) : '—'}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Паспорт</td>
                                <td>{formatPassport(d.passport)}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Пройден мед. осмотр</td>
                                <td>{getMedicalExam()}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">В черном списке</td>
                                <td>{getBlacklist()}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Контрагент</td>
                                <td>{d.contractor_name || '—'}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Должность</td>
                                <td>{d.position || obj.position || '—'}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Отдел</td>
                                <td>{d.department || obj.department || '—'}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Тип объекта доступа</td>
                                <td>{d.object_type || obj.object_type || '—'}</td>
                              </tr>
                              <tr>
                                <td className="sigur-approval-object-modal__label">Ранее имел доступ</td>
                                <td>{d.had_access_history ? 'Да' : 'Нет'}</td>
                              </tr>
                              {d?.additional_attrs && Object.entries(d.additional_attrs).map(([key, value]) => (
                                <tr key={key}>
                                  <td className="sigur-approval-object-modal__label">
                                    {key}
                                  </td>
                                  <td>
                                    {value}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-5">
                      {Number.isFinite(accessObjectId) ? (
                        <SigurFilesBlock
                          key="modal_files"
                          project_name="access_objects"
                          object_id={accessObjectId}
                          files_schema={d.files_schema || []}
                          files={d.files || []}
                          document_dates={d.document_dates || []}
                          fileUploaded={() => {}}
                          getChoice={this.getChoice}
                          isRenderChevron={false}
                          viewOnly
                        />
                      ) : (
                        <div className="text-muted">Файлы недоступны</div>
                      )}
                    </div>
                  </div>
                )
              })()}

              <div className="mb-3 mt-3">
                <label className="form-label">Причина отказа</label>
                <textarea
                  className="form-control"
                  rows={3}
                  value={this.state.objectStatusRefusalReason}
                  disabled={!this.state.can_set_object_status}
                  onChange={(e) => this.setState({ objectStatusRefusalReason: e.target.value })}
                  placeholder="Укажите причину при отказе"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                disabled={!this.state.can_set_object_status}
                onClick={() => that.submitObjectStatus('approved')}
              >
                Согласовано
              </button>
              <button
                type="button"
                className="btn btn-danger"
                disabled={!this.state.can_set_object_status}
                onClick={() => that.submitObjectStatus('refused')}
              >
                Отказано
              </button>
              <button type="button" className="btn btn-secondary" onClick={this.closeObjectStatusModal}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModesTable() {
    const { modes } = this.state
    const formatDate = (v) => (v || '—')
    const canAddModes = !!this.state.can_add_mode
    const canRemoveModes = this.hasPerm('remove_modes')
    return (
      <div>
        {canAddModes && (
          <div className="mb-3">
            <button type="button" className="btn btn-primary btn-sm" onClick={this.openModesModal}>
              Добавить режим
            </button>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Название</th>
                <th>Уровень</th>
                <th>Начало действия</th>
                <th>Окончание действия</th>
                {canRemoveModes && <th style={{ width: '50px' }}></th>}
              </tr>
            </thead>
            <tbody>
              {modes.length === 0 ? (
                <tr>
                  <td colSpan={canRemoveModes ? 5 : 4} className="text-center text-muted">
                    Нет выбранных режимов
                  </td>
                </tr>
              ) : (
                modes.map((m) => (
                  <tr key={m.id}>
                    <td>{m.name}</td>
                    <td>{m.level != null ? m.level : '—'}</td>
                    <td>{formatDate(m.start_date)}</td>
                    <td>{formatDate(m.end_date)}</td>
                    {canRemoveModes && (
                      <td>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => this.handleRemoveMode(m.mode_id)}
                          title="Удалить"
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  handleSelectAllFound(isCancelSelected) {
    this.setState({isModalModesSelectedAll: !isCancelSelected, modalModesSelectedIds: new Set(), modalModesExcludedIds: new Set()})
  }

  renderModesModal() {
    if (!this.state.showModesModal) return null
    const {
      modalModes,
      modalModesPage,
      modalModesTotalPages,
      modalModesFilters,
      modesFilterOptions,
      modalModesSelectedIds,
      modalModesExcludedIds,
      isModalModesSelectedAll,
      modelModesAlreadyAddedModesCnt
    } = this.state
    const isCancelSelected = (
      (isModalModesSelectedAll && !Array.from(modalModesExcludedIds).length)
      || (Array.from(modalModesSelectedIds).length === Array.from(modalModes).length - modelModesAlreadyAddedModesCnt)
    )

    const formatDate = (v) => (v || '—')
    return (
      <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="modes_modal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Доступные режимы</h5>
              <button type="button" className="btn-close" onClick={this.closeModesModal} aria-label="Закрыть" />
            </div>
            <div className="modal-body">
              <div className="row g-2 mb-3">
                <div className="col-md-4">
                  <label className="form-label small">Название режима</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={modalModesFilters.name}
                    onChange={(e) =>
                      this.setState((s) => ({
                        modalModesFilters: { ...s.modalModesFilters, name: e.target.value },
                      }))
                    }
                    placeholder="Подстрока в названии"
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small">Уровень</label>
                  <select
                      name="level"
                      className="form-select form-select-sm js-select2-modal"
                      value={modalModesFilters.level}
                      onChange={(e) =>
                        this.setState({
                          modalModesFilters: { ...modalModesFilters, level: e.target.value },
                        })
                      }
                    >
                      <option value="">Все</option>
                      {this.state.modalModesLevelChoices.map((v) => (
                        <option key={v[0]} value={v[1]}>{v[1]}</option>
                      ))}
                    </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label small">Территория</label>
                  <select
                    className="form-select form-select-sm"
                    value={modalModesFilters.territory_name || ''}
                    onChange={(e) =>
                      this.setState((s) => ({
                        modalModesFilters: { ...s.modalModesFilters, territory_name: e.target.value || '' },
                      }))
                    }
                  >
                    <option value="">—</option>
                    {(modesFilterOptions.territories || []).map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12 mt-2">
                  <button type="button" className="btn btn-primary btn-sm me-2" onClick={this.handleModesSearch}>
                    Найти
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm me-2" onClick={this.handleResetModesFilters}>
                    Сброс
                  </button>
                  <button className="btn btn-secondary btn-sm" onClick={() => this.handleSelectAllFound(isCancelSelected)}>
                    {isCancelSelected ? 'Отменить выбор' : 'Выбрать все найденные'}
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>Название</th>
                      <th>Уровень</th>
                      <th>Начало действия</th>
                      <th>Окончание действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalModes.map((m) => (
                      <tr
                        key={m.id}
                        className={
                          m.already_added ? 'table-secondary' : m.match_request_territory ? 'table-info' : ''
                        }
                      >
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={
                              modalModesSelectedIds.has(m.id)
                              || m.already_added
                              || isModalModesSelectedAll && !modalModesExcludedIds.has(m.id)
                            }
                            disabled={m.already_added}
                            onChange={() => this.handleToggleMode(m.id, m.already_added)}
                          />
                        </td>
                        <td>{m.name}</td>
                        <td>{m.level != null ? m.level : '—'}</td>
                        <td>{formatDate(m.start_date)}</td>
                        <td>{formatDate(m.end_date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {modalModesTotalPages > 1 && (
                <nav className="mt-3">
                  <ul className="pagination pagination-sm justify-content-center">
                    <li className={`page-item ${modalModesPage === 1 ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalModesPage > 1) this.loadModalModes(modalModesPage - 1)
                        }}
                      >
                        Назад
                      </a>
                    </li>
                    {[...Array(modalModesTotalPages)].map((_, idx) => (
                      <li key={idx} className={`page-item ${modalModesPage === idx + 1 ? 'active' : ''}`}>
                        <a
                          className="page-link"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            this.loadModalModes(idx + 1)
                          }}
                        >
                          {idx + 1}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${modalModesPage === modalModesTotalPages ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalModesPage < modalModesTotalPages) this.loadModalModes(modalModesPage + 1)
                        }}
                      >
                        Вперед
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeModesModal}>
                Отмена
              </button>
              <button type="button" className="btn btn-primary" onClick={this.handleApplyModes}>
                Применить
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderAccessObjectsTable() {
    const { accessObjects } = this.state
    return (
      <Panel header="Состав группы" key="access_objects_table">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Имя</th>
                <th>Должность</th>
                <th>Отдел</th>
                <th>Тип объекта доступа</th>
                <th>Пройден мед. осмотр</th>
              </tr>
            </thead>
            <tbody>
              {accessObjects.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    Нет связанных объектов доступа
                  </td>
                </tr>
              ) : (
                accessObjects.map((ao) => (
                  <tr key={ao.id}>
                    <td>{ao.name}</td>
                    <td>{ao.position}</td>
                    <td>{ao.department}</td>
                    <td>{ao.object_type}</td>
                    <td>{ao.medical_exam}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  renderObjectGroupsTable() {
    const { objectGroups, expandedGroupId, groupAccessObjects } = this.state
    return (
      <Panel header="Группы посетителей" key="object_groups_table">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Наименование</th>
                <th>Количество людей в группе</th>
              </tr>
            </thead>
            <tbody>
              {objectGroups.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    Нет групп объектов доступа
                  </td>
                </tr>
              ) : (
                objectGroups.map((og) => (
                  <React.Fragment key={og.id}>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0 text-secondary"
                          onClick={() => this.toggleGroupExpand(og.object_group_id)}
                          aria-expanded={expandedGroupId === og.object_group_id}
                        >
                          <i
                            className={`ti ti-chevron-${expandedGroupId === og.object_group_id ? 'down' : 'right'}`}
                          />
                        </button>
                      </td>
                      <td>{og.name}</td>
                      <td>{og.access_objects_count}</td>
                    </tr>
                    {expandedGroupId === og.object_group_id && (
                      <tr>
                        <td colSpan={3} className="p-0 bg-light">
                          <div className="p-2">
                            <table className="table table-sm table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th>Имя</th>
                                  <th>Должность</th>
                                  <th>Отдел</th>
                                  <th>Тип объекта доступа</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(groupAccessObjects[og.object_group_id] || []).map((ao) => (
                                  <tr key={ao.id}>
                                    <td>{ao.name}</td>
                                    <td>{ao.position}</td>
                                    <td>{ao.department}</td>
                                    <td>{ao.object_type}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  renderApproveModal() {
    if (!this.state.showApproveModal) return null
    return (
      <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="approve_modal"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Согласование заявки</h5>
              <button type="button" className="btn-close" onClick={this.closeApproveModal} aria-label="Закрыть" />
            </div>
            <div className="modal-body">
              <label className="form-label">Примечание (необязательно)</label>
              <textarea
                className="form-control"
                rows={4}
                value={this.state.approveNote}
                onChange={(e) => this.setState({ approveNote: e.target.value })}
                placeholder="Примечание"
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeApproveModal}>
                Закрыть
              </button>
              <button type="button" className="btn btn-primary" onClick={this.submitApprove}>
                Согласовать
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderReturnModal() {
    if (!this.state.showReturnModal) return null
    return (
      <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="return_modal"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Возврат заявки на доработку</h5>
              <button type="button" className="btn-close" onClick={this.closeReturnModal} aria-label="Закрыть" />
            </div>
            <div className="modal-body">
              <label className="form-label">Примечание (обязательно)</label>
              <textarea
                className={`form-control ${this.state.returnNoteError ? 'is-invalid' : ''}`}
                rows={4}
                value={this.state.returnNote}
                onChange={(e) => this.setState({ returnNote: e.target.value, returnNoteError: null })}
                placeholder="Укажите причину возврата"
              />
              {this.state.returnNoteError && (
                <div className="invalid-feedback d-block">{this.state.returnNoteError}</div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeReturnModal}>
                Закрыть
              </button>
              <button type="button" className="btn btn-primary" onClick={this.submitReturn}>
                Вернуть
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModals() {
    const modals = []
    if (this.props.search_form) {
      modals.push(
        <ApprovalsModalSearch
          key="search"
          project_name={this.project_name}
          schema={this.props.search_form}
          data={this.props.search_data}
          onSearch={this.onSearch}
          choices={this.props.choices}
        />
      )
    }
    return [...modals, this.renderApproveModal(), this.renderReturnModal(), this.renderModesModal()]
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
